import isNil from 'lodash/isNil'
import {EventTypes} from '../../store/enum'
import * as utils from '../../utils'

// This is temporary for the time being and will be removed.
// MyTime will be adding a field to their API to allow us to add showroom location details.
const locationDescription = {
  'salt-lake-city-area':
    "We're located on the First Floor in the Men's Furnishings and Suits department.",
  'mission-viejo':
    "We're located on the First Floor in the Men's Furnishings and Suits department.",
  'seattle-area': "We're located on the First Floor in the Men's Furnishings and Suits department.",
  'denver-area': "We're located on the First Floor in the Men's Furnishings and Suits department.",
  'washington-dc':
    "We're located on the Second Floor in the Men's Furnishings and Suits department.",
  'boston-area': "We're located on the First Floor in the Men's Furnishings and Suits department.",
  atlanta: "We're located on the First Floor in the Men's Furnishings and Suits department.",
  houston:
    "We're located on the First Floor in the Men's Clothing department, between the North and West entrances.",
  austin:
    "We're located on the First Floor in the Men's Furnishings and Suits department, across from the Men's Shoes department.",
  'philadelphia-area':
    "We're located on the First Floor in the Men's Furnishings and Suits department.",
  miami:
    "We're located on the First Floor in the Men's Furnishings and Suits department, near the South entrance.",
  paramus: "We're located on the Second Floor in the Men's Furnishings and Suits department.",
  glendale: "We're located on the Third Floor in the Men's Furnishings and Suits department.",
  baltimore: "We're located on the Second Floor in the Men's Furnishings and Suits department.",
  'chicago-area': "We're located on the First Floor in the Men's Furnishings and Suits department.",
  charlotte: "We're located on the First Floor in the Men's Furnishings and Suits department.",
  pleasonton: "We're located on the Second Floor in the Men's Furnishings and Suits department.",
  minneapolis:
    "We're located on the First Floor in the Men's Furnishings and Suits department, near the East entrance.",
  arlington: "We're located on the Second Floor in the Men's Furnishings and Suits department.",
  'detroit-area': "We're located on the First Floor in the Men's Furnishings and Suits department.",
  columbus: "We're located on the First Floor in the Men's Grooming department.",
  'long-island': "We're located on the First Floor in the Men's Furnishings and Suits department.",
}

/**
 * Helper Function - returns location instructions
 *
 * @param {Boolean} isNordstrom boolean whether showroom is a nordstrom showroom or not
 * @param {String} slug showroom slug
 * @returns {String} returns first image url in backGround object
 */
export const getDirections = (isNordstrom, slug) => {
  if (isNordstrom) {
    return locationDescription[slug] || "We're located in the Men's Department."
  }
  return undefined
}

/**
 * Constructs an errors object for the Appointment Form validation
 *
 * @param {Object}  fields                 The form fields and their values
 * @param {Boolean} [includePartnerFields] Whether to include partner info in validation
 * @returns {Object}
 */
export function validateAppointmentForm(fields, includePartnerFields = false) {
  const errors = {}
  const validateInput = (value, prop) => {
    if (isNil(value) || value === '') {
      errors[prop] = 'Required.'
    }
  }
  const validateEmail = (input, prop) => {
    if (!input) {
      errors[prop] = 'Required.'
    } else if (!utils.isEmailAddress(input)) {
      errors[prop] = 'Invalid email address.'
    }
  }

  validateInput(fields.firstName, 'firstName')
  validateInput(fields.lastName, 'lastName')
  validateInput(fields.eventDate, 'eventDate')
  validateInput(fields.eventId, 'eventId')
  validateInput(fields.eventType, 'eventType')
  validateEmail(fields.emailAddress, 'emailAddress')

  if (fields.eventType === EventTypes.wedding) {
    validateInput(fields.weddingRole, 'weddingRole')
  }
  if (!fields.mobilePhoneNumber) {
    errors.mobilePhoneNumber = 'Required.'
  } else if (!utils.isTenDigitPhoneNumber(fields.mobilePhoneNumber)) {
    errors.mobilePhoneNumber = 'Invalid phone number.'
  } else if (!utils.isValidFirstDigitPhoneNumber(fields.mobilePhoneNumber)) {
    errors.mobilePhoneNumber = 'Please enter a valid phone number starting with the area code.'
  }

  if (includePartnerFields) {
    validateEmail(fields.partnerEmail, 'partnerEmail')
    validateInput(fields.partnerFirstName, 'partnerFirstName')
    validateInput(fields.partnerLastName, 'partnerLastName')
  }

  return errors
}
